import React, { useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChartLine,
    faGraduationCap,
    faUserCheck,
    faExclamationTriangle,
    faTasks,
    faCertificate,
    faHardHat
} from '@fortawesome/free-solid-svg-icons';
import StaffSafetyDashboard from './StaffSafetyDashboard';
import TrainingRecords from './TrainingRecords';
import Inductions from './Inductions';
import IncidentReports from './IncidentReports';
import AssignedTasks from './AssignedTasks';
import Certifications from './Certifications';
import PPEIssuance from './PPEIssuance';
import ComingSoonModal from '../../pages/ComingSoon/ComingSoonModal';
import './StaffSafety.css';

const SHOWCASE_MODE = false;
const COMING_SOON_SECTIONS = ['training', 'inductions', 'incidents', 'tasks', 'certifications', 'ppe'];

const menuItems = [
    { id: 'dashboard',      title: 'Staff Dashboard',       icon: faChartLine },
    { id: 'training',       title: 'Training Records',      icon: faGraduationCap },
    { id: 'inductions',     title: 'Inductions',            icon: faUserCheck },
    { id: 'incidents',      title: 'Incident Reports',      icon: faExclamationTriangle },
    { id: 'tasks',          title: 'Assigned Safety Tasks', icon: faTasks },
    { id: 'certifications', title: 'Certifications',        icon: faCertificate },
    { id: 'ppe',            title: 'PPE Issuance Logs',     icon: faHardHat },
];

const COMPONENT_MAP = {
    dashboard: StaffSafetyDashboard,
    training: TrainingRecords,
    inductions: Inductions,
    incidents: IncidentReports,
    tasks: AssignedTasks,
    certifications: Certifications,
    ppe: PPEIssuance
};

const SUB_NAV_ITEMS = menuItems.map(s => ({
    id: s.id,
    label: s.title,
    icon: <FontAwesomeIcon icon={s.icon} />
}));

const StaffSafety = () => {
    const { id } = useParams();
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);
    const [comingSoonFeatureName, setComingSoonFeatureName] = useState('');

    const ctx = useOutletContext() || {};
    const activeSubSection = ctx.activeSubSection || 'dashboard';
    const setActiveSubSection = ctx.setActiveSubSection || (() => {});

    const handleSectionClick = (sectionId) => {
        if (SHOWCASE_MODE && COMING_SOON_SECTIONS.includes(sectionId)) {
            const item = menuItems.find(m => m.id === sectionId);
            setComingSoonFeatureName(item ? item.title : 'This Feature');
            setShowComingSoonModal(true);
            return;
        }
        setActiveSubSection(sectionId);
    };

    const renderContent = () => {
        const Component = COMPONENT_MAP[activeSubSection] || COMPONENT_MAP.dashboard;
        if (activeSubSection === 'dashboard') return <Component propertyId={id} onNavigate={handleSectionClick} />;
        return <Component propertyId={id} />;
    };

    const visiblePills = activeSubSection === 'dashboard'
        ? SUB_NAV_ITEMS.filter(i => i.id === 'dashboard')
        : SUB_NAV_ITEMS;

    const pillNav = (
        <nav className="rs-subnav">
            {visiblePills.map((item) => (
                <button
                    key={item.id}
                    className={`rs-pill${activeSubSection === item.id ? ' rs-pill-active' : ''}`}
                    onClick={() => handleSectionClick(item.id)}
                >
                    {item.icon}
                    <span>{item.label}</span>
                </button>
            ))}
        </nav>
    );

    return (
        <div className="staff-safety-container">
            <div className="rs-subnav-mobile-wrap">{pillNav}</div>
            <div className="staff-safety-content">
                <div className="staff-safety-main">
                    <div className="rs-subnav-desktop-wrap">{pillNav}</div>
                    {renderContent()}
                </div>
            </div>
            <ComingSoonModal
                isOpen={showComingSoonModal}
                onClose={() => setShowComingSoonModal(false)}
                featureName={comingSoonFeatureName}
            />
        </div>
    );
};

export default StaffSafety;
